import { render, staticRenderFns } from "./TicketStatusBadge.vue?vue&type=template&id=47e4bae8&"
import script from "./TicketStatusBadge.vue?vue&type=script&lang=js&"
export * from "./TicketStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports